module.exports = __webpack_public_path__ + "img/HYprojec.4ae188ed.png";